import React, {useState} from "react";
import {dec2bin, getDescription} from "./CvParser";

import { Input } from '@base-ui-components/react/input';
import ValidatingInput from "./ValidatingInput.tsx";

function readArray(data, key0) {
    return data?.[key0] ? Array.isArray(data?.[key0]) ? data?.[key0] : [data?.[key0]] : []
}

const boxstyle = {
    border: '1px solid #333333',
    margin: '10px',
}

const container_style = {
    //width: "100%",
    display: "flex",
    //flexDirection: "row",
    //justifyContent: "right",
    padding: "5px",
}

const select_style = {
    //width: "100%",
}

const Bit = ({data, value, onChange}) => {

    const number = data?.number || 255

    function setValue() {
        onChange(value ^ (1 << number))
    }

    const dav = (value & ( 1 << number)) > 0
    return (
        <div style={container_style}>
            <Input type={'checkbox'} checked={dav} onChange={() => setValue()}/>
            <label>bit:{number} {getDescription(data)}</label>
        </div>
    )
}

const BitSelection = ({data, value, onChange}) => {
    const number = data?.number || 255

    function setValue() {


        onChange(value ^  (1 << number))
    }

    return (
        <div style={container_style}>
            <select  style={select_style} onChange={() =>setValue()} value={ (1 << parseInt(number) & value ) > 0 ? 1:0 }>
                {readArray(data, 'ct:option').map((it, i) => {
                    return <option key={i} value={it?.value}>{it?.value} | {getDescription(it)}</option>
                })}
            </select>
            <label>bit:{number}</label>
        </div>
    )
}


const BitGroup = ({data, value, onChange}) => {
    const number = data?.number || 255
    const {possibleValues} = data

    const [localVal, setLocalVal] = useState(parseInt(value))

    const pw = possibleValues && possibleValues.split('-')
    if( pw ) {
        console.log(pw)
    }

    let mask = 0;
    function setValue(val) {
        const v2 = ((value & ~(mask)) + parseInt(val)) & 0xFF
        //onChange(v2)

        const v3 = parseInt(value) - parseInt(localVal) + parseInt(val)
        if( v2 !== v3) {
            console.error("CvBitSelect : v2 !== v3")
        }
        console.log(`BitGroup# ${value} -> ${localVal} --> ${v3} :: ${v2} | ${mask}`)

        console.log(`V2: ${v2} -- ${v3}`)

        setLocalVal( parseInt(val))
        onChange(v3)
    }
    const o = readArray(data, 'ct:option')
    const opts = o?.map((option, i) => {

            const vx = option?.value
            mask |= vx

            return <option key={i} value={(vx & mask)}>{vx & mask} | {getDescription(option)}</option>
    })


    const group_array = readArray(data, 'ct:group')
    if( group_array.length > 0 ) {
        console.log("----- > GROUP ARRAY", data)
    }


    //console.log("GROUP", data)
    return(
        <div style={container_style}>
            <select style={select_style} onChange={(e) =>setValue(e.target.value & mask)} value={value & mask}>
                {opts}
            </select>
            <label>group:{number} | {getDescription(data)}</label>
        </div>
    )
}

const Partial = ({data, value, onChange}) => {
    const number = data?.number || 255
    const {possibleValues} = data

    const [localVal, setLocalVal] = useState(parseInt(value))

    const pw = possibleValues.split('-')
    //console.log(pw)

    function setValue(val) {
        //onChange(value ^  (1 << number))

        const v3 = parseInt(value) - parseInt(localVal) + parseInt(val)
        const v3x = value - localVal + parseInt(val)
        console.log(`# ${val} -> ${localVal} --> ${v3} ${v3x}`)

        setLocalVal( parseInt(val))
        onChange(v3)
    }

    // <label>PARTIAL {getDescription(data)} {possibleValues}</label>
    // <input style={select_style} onChange={(e) =>setValue(e.target.value)}/>

    // <ValidatingInput value={value} readOnly={false} onChange={(e) => setValue(e)} constraint={possibleValues} showBits={false}/>
    return (
        <div style={container_style}>
            <label>{getDescription(data)} {possibleValues} {'partial TODO'}</label>
        </div>
    )
}


const CvEditSelect = ({data, activeItems}) => {
    const {mode, possibleValues, number, ...rest} = data

    const [val, setVal] = useState(0)
    function bitChanged(valx) {
        setVal(valx)
    }

    //const items = bitProcessor(data)
    let ret = []
    const bit_array0 = readArray(data, 'ct:bit')
    const bit_sel_array0 = readArray(data, 'ct:bitSelection')

    for( let i = 0; i < 8; i++ ) {

        if( activeItems && activeItems.length > 0 ) {
            if ( !activeItems?.includes(`bit:${i}`)) {
                continue
            }
        }

        const b = bit_array0.find(it => parseInt(it?.number) === i)
        if( b) {
            ret.push(<Bit key={`sel_bit_${i}`} data={b} value={val} onChange={bitChanged} activeItems={activeItems}/>)
        } else {
            const d = bit_sel_array0.find(it => parseInt(it?.number) === i)
            if( d) {
                ret.push(<BitSelection key={`sel_sel_bit${i}`} data={d} value={val} onChange={bitChanged} activeItems={activeItems}/>)
            } else {
                //console.error(`no editor found for bit: ${i}`)
            }
        }
    }


    const group_array = readArray(data, 'ct:group')
    const bitgroup = group_array.map((it, i) => {
        //console.log(`GROUP ARRAY B ${i}`, it)
        return <BitGroup key={i} data={it} value={val} onChange={bitChanged} activeItems={activeItems}/>
    })

    const partial_array = readArray(data, 'ct:partial')
    const partial = partial_array.map((it, i) => {
        //console.log(`PARTIAL ARRAY B ${i}`, it)
        return <Partial key={i} data={it} value={val} onChange={bitChanged} activeItems={activeItems}/>
    })

    let vals = possibleValues
    if( vals?.length > 20) {
        vals = vals.substring(0, 20) + "..."
    }

    const outer_style = {
        border: "1px solid black",
        width: "100%",
    }

    //<input style={{}} readOnly={false} value={val} onChange={(e) => bitChanged(e.target.value)}/>

    return (
        <div style={outer_style}>
            {activeItems && 'ACTIVE:' + activeItems}
            <div style={boxstyle}>

                <ValidatingInput value={val} onChange={(e) => bitChanged(e)} constraint={possibleValues}/>

            </div>

            {bitgroup.length > 0 &&
            <div style={boxstyle}>
                {bitgroup}
            </div>}

            {ret.length > 0 &&
            <div style={boxstyle}>
                {ret}
            </div>}

            {partial.length > 0 &&
            <div style={boxstyle}>
                {partial}
            </div>}
        </div>
    )
}

export default CvEditSelect;